<template>
  <div class="quote__invent">
    <p>
      <span>{{member.firstName}} {{member.lastName}}</span>
      <span v-show="!disableAddons" class="travel-covers__grid">
      <span v-if="covidCover" class="travel-covers">{{ $t('qic_covid_cover') }}</span>
      <span v-if="member.sportCover" class="travel-covers">{{ $t('qic_winter_cover') }}</span>
    </span>
    </p>
    <ul>
      <li>{{ member.relationName}}</li>
      <slot name="moreInfo" />
      <li v-if="member.passport">{{$t('qic_quote_member_passport')}}: {{ member.passport }}</li>
      <li v-if="member.abroadPassport"> {{$t('qic_quote_member_passport')}}: {{ member.abroadPassport }}</li>
      <li v-if="formattedDateOfBirth">{{$t('qic_user_dob')}}: {{ formattedDateOfBirth }}</li>
      <li v-if="member.nationalityName"> {{$t('inbound_nationality_nationality')}}: {{ member.nationalityName }}</li>
      <li v-if="member.dateExp">{{$t('qic_quote_member_exp_date')}}: {{ formattedExpDate }}</li>
      <li v-if="qidOn">{{ $t('qic_quote_member_qid') }}: {{ member.passport}}</li>
    </ul>
  </div>
</template>

<script>
import { formatDate } from '../../utils/formatDate'

export default {
  name: 'QuoteInsuredMember',
  props: {
    member: { type: Object },
    qidOn: { type: Boolean, default: false },
    disableAddons: { type: Boolean, default: false },
    covidCover: { type: Boolean, default: false }
  },
  data () {
    return {
      locale: this.$i18n.locale || 'en'
    }
  },
  computed: {
    formattedDateOfBirth () {
      return formatDate(this.member.dateOfBirth, this.locale, 'dd MMM yyyy')
    },
    formattedExpDate () {
      return formatDate(this.member.dateExp, this.locale, 'dd.MM.yyyy')
    }
  },
  methods: {
  },
  mounted () {}
}
</script>
